import React from 'react'
import { Skeleton } from '@/components/ui/skeleton'
import { cn } from '@/lib/utils'
import { folderIndentClass } from './folder-tree'

// Level and name width per placeholder row, so the skeleton reads as a nested tree.
const ROWS: Array<[number, string]> = [
  [0, 'w-32'],
  [1, 'w-24'],
  [1, 'w-28'],
  [0, 'w-36'],
  [0, 'w-20'],
]

const FolderTreeSkeleton: React.FC = () => (
  <div className="space-y-0.5">
    {ROWS.map(([level, width], i) => (
      <div key={i} className={cn('flex h-8 items-center gap-1.5 pr-2', folderIndentClass(level))}>
        <span className="h-5 w-5 shrink-0" />
        <Skeleton className="h-4 w-4 shrink-0" />
        <Skeleton className={cn('h-4', width)} />
      </div>
    ))}
  </div>
)

export default FolderTreeSkeleton
